jQuery(document).ready(($)=>{

  $('.review_slider').slick({
    dots: true,
    arrows: false,
    infinite: false,
    speed: 300,
    autoplay: true,
    autoplaySpeed: 5000,
    adaptiveHeight: true,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  $("body").on("click", ".product-offer-header", function (){
    $(this).toggleClass("active");
    $(this).next().toggleClass("active");
  })

  $("body").on("click", ".product-offer-copy-code", function () {
    var copy_text = $(this).find(".product-offer-copied");
    var text = $(this)
      .closest(".product-offer-block")
      .find(".product-offer-code")
      .text();
    var $temp = $("<input>");

    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.html("Copied");
    setTimeout(function () {
      copy_text.html("");
    }, 1000);
  });

}); 